module.exports = __webpack_public_path__ + "static/b-8848fc0a1db759771e42864cdd3e4c2a.jpg";